<template>
  <div>
    <swiper :options="swiperOption" ref="mySwiper">
      <swiper-slide>
        <div class="swiper">
          <div class="pic">
            <img
              src="/static/img/p3.jpg"
              width="100%"
              alt="蓝鲨 Robor 扭矩大功率足"
            />
          </div>
          <div class="text t3">
            <div class="aniel" :class="{ ani2: a1 }">
              R 取自拉丁语词根 Robor，意为力量。蓝鲨 R
              系列搭载高速无刷永磁边挂电机，它拥有轮毂电机望尘莫及的强大扭矩，使整车加速更快，<br />爬坡性能更强，为骑行者带来驾驭竞赛摩托般肾上腺素飙升的快感。
            </div>
          </div>
          <div class="text t3a">
            <div>
              <span class="aniel" :class="{ ani: a2 }"
                ><span class="fs_big">5,000</span>
                <span class="fs_tiny">w</span></span
              ><br />
              <span class="fs_tiny color_gray aniel" :class="{ ani1: a2 }">
                峰值功率
              </span>
            </div>
            <div>
              <span class="aniel" :class="{ ani: a2 }"
                ><span class="fs_big">5,500</span>
                <span class="fs_tiny">rpm</span></span
              ><br />
              <span class="fs_tiny color_gray aniel" :class="{ ani1: a2 }">
                最高转速
              </span>
            </div>
            <div>
              <span class="aniel" :class="{ ani: a2 }"
                ><span class="fs_big">201</span>
                <span class="fs_tiny">N·m</span></span
              ><br />
              <span class="fs_tiny color_gray aniel" :class="{ ani1: a2 }">
                轮上扭矩
              </span>
            </div>
            <div>
              <span class="aniel" :class="{ ani: a2 }">
                <span class="fs_big">80</span>
                <span class="fs_tiny">km/h</span>
              </span>
              <br />
              <span class="fs_tiny color_gray aniel" :class="{ ani1: a2 }">
                最高速度
              </span>
            </div>
            <div>
              <span class="aniel" :class="{ ani: a2 }">
                <span class="fs_big">40</span>
                <span class="fs_tiny">%</span>
              </span>
              <br />
              <span class="fs_tiny color_gray aniel" :class="{ ani1: a2 }">
                爬坡能⼒
              </span>
            </div>
            <div>
              <span class="aniel" :class="{ ani: a2 }">
                <span class="fs_big">4.9</span>
                <span class="fs_tiny">s</span>
              </span>
              <br />
              <span class="fs_tiny color_gray aniel" :class="{ ani1: a2 }">
                0-50 km/h 加速度
              </span>
            </div>
          </div>
        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="swiper">
          <div class="pic">
            <img
              src="/static/img/p3-2.jpg"
              width="100%"
              alt="蓝鲨 Robor 扭矩大功率足"
            />
          </div>
          <div class="text t3">
            <div>
              20
              铬锰钛合金齿轮组通过两级变速，将动力传递给驱动轮，不仅规避链传动系统的多边形效应，与带传动相比又具有传动比稳定、<br />传动效率高和使用寿命长的优势，在传动方式上比中置电机更具优越性。
            </div>
          </div>
        </div>
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
  </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
export default {
  data() {
    return {
      a1: false,
      a2: false,
      swiperOption: {
        loop: false,
        resistanceRatio: 0,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      }
    }
  },
  components: {
    swiper,
    swiperSlide
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper
    }
  },
  methods: {
    startani1() {
      this.a1 = true
    },
    startani2() {
      this.a2 = true
    }
  }
}
</script>

<style lang="less" scoped>
@import '../../assets/css/swiper.less';
.swiper-pagination {
  bottom: 5vw !important;
}
.t3 {
  top: 180px;
  left: 0;
  right: 0;
  margin: 0 auto;
  text-align: center;
  .t3_1 {
    margin-bottom: 10px;
  }
  .t3_2 {
    margin-bottom: 20px;
  }
}
.t3a {
  display: flex;
  display: -webkit-flex;
  justify-content: space-between;
  left: 20vw;
  bottom: 10vw;
  right: 20vw;
  text-align: center;
}

.aniel {
  position: relative;
  opacity: 0;
}
.ani {
  animation: tani 1s forwards;
}
.ani1 {
  animation: tani 1s forwards 0.1s;
}
.ani2 {
  animation: tani 1s forwards 0.2s;
}

@keyframes tani {
  from {
    top: 60px;
    opacity: 0;
  }
  to {
    top: 0;
    opacity: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/swiper/swiper3.vue